export const formatEstimatedHours = (hours?: null | number) => {
  return hours && hours > 0
    ? hours > 1
      ? `${hours} hrs/wk`
      : `${hours} hr/wk`
    : null;
};
